import * as React from 'react';
import {faSearch, faTimesCircle} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useEffect, useRef, useState} from 'react';

export interface FilterInputProps {
    className?: string;
    clearInput?: boolean;
    onInput: (value: string) => void;
    placeholder?: string;
}

export const FilterInput = ({className, clearInput, onInput, placeholder}: FilterInputProps) => {
    const [filter, setFilter] = useState(``);
    const filterBox = useRef<HTMLInputElement>();

    // Clear filter externally if directed
    useEffect(() => {
        if (clearInput) {
            clearFilterBoxText();
        }
    }, [clearInput]);

    /**
     * Clears filter text
     */
    const clearFilterBoxText = () => {
        filterBox.current.value = ``;
        filterBox.current.dispatchEvent(new Event(`input`, {bubbles: true}));
    };

    /**
     * Template
     */
    return (
        <div>
            <div className={`tw-relative tw-flex tw-flex-nowrap tw-items-stretch tw-w-full ${className}`}>
                <div className="tw-mr-[-1px] tw-flex">
                    <span className="tw-flex tw-items-center tw-py-1.5 tw-px-3 tw-mb-0 tw-text-base tw-font-normal tw-leading-normal tw-text-center tw-whitespace-nowrap tw-border tw-rounded-sm tw-h-[52px] tw-bg-white">
                        <FontAwesomeIcon
                            className="tw-text-gray-200"
                            icon={faSearch}
                        />
                    </span>
                </div>
                <input
                    aria-label="filter"
                    className="focus:tw-outline-1 focus:tw-outline-sky-200 tw-font-normal tw-bg-white tw-border tw-leading-normal tw-relative tw-w-[1%] tw-min-w-0 tw-mb-0 tw-flex tw-flex-grow tw-rounded-none tw-h-[52px] tw-text-base tw-indent-2 tw-border-x-0 focus:!tw-border-sky-300"
                    id="filterbox"
                    onInput={(e) => {
                        onInput(e.currentTarget.value);
                        setFilter(e.currentTarget.value);
                    }}
                    placeholder={placeholder || `Search`}
                    ref={filterBox}
                    type="text"
                />
                <div className="tw-ml-[-1px] tw-flex">
                    <span className="tw-h-[52px] tw-flex tw-items-center tw-py-1.5 tw-px-3 tw-mb-0 tw-text-base tw-font-normal tw-leading-normal tw-text-center tw-whitespace-nowrap tw-border tw-rounded-sm tw-bg-white">
                        {filter && (
                            <FontAwesomeIcon
                                className="tw-text-gray-200"
                                icon={faTimesCircle}
                                onClick={clearFilterBoxText}
                            />
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
};
